import React from 'react'

import {
  DEFAULT_EXAMPLE_INVOICE_PDF_URL,
  getExampleInvoicePdfUrl,
} from '../../../lib/exampleInvoicePdf'
import { useVisitorMarket } from '../../../hooks/useVisitorMarket'

type Props = {
  className?: string
  /** Pre-rendered static homepage: href set by build-injected script. */
  staticMode?: boolean
}

const ExampleInvoiceLink: React.FC<Props> = ({ className, staticMode = false }) => {
  if (staticMode) {
    return (
      <a
        id='example-invoice-link'
        href={DEFAULT_EXAMPLE_INVOICE_PDF_URL}
        className={className}
        target='_blank'
        rel='noopener noreferrer'
      >
        View example invoice
      </a>
    )
  }

  return <ExampleInvoiceLinkClient className={className} />
}

const ExampleInvoiceLinkClient: React.FC<{ className?: string }> = ({ className }) => {
  const { market } = useVisitorMarket()

  return (
    <a
      href={getExampleInvoicePdfUrl(market?.code)}
      className={className}
      target='_blank'
      rel='noopener noreferrer'
    >
      View example invoice
    </a>
  )
}

export default ExampleInvoiceLink
